import cx from 'classnames';
import _ from 'lodash';
import { ElementType, HTMLAttributes, isValidElement, ReactNode } from 'react';
import css from './NoResults.module.scss';

interface INoResultsProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  icon?: ElementType | ReactNode;
  iconColor?: 'gray' | 'yellow';
  message?: string;
  title?: string | ((args: { className: string }) => ReactNode);
}

export const NoResults = ({
  className,
  children,
  icon,
  iconColor = 'gray',
  message = 'Adjust your search or filters',
  title = 'No results',
  ...rest
}: INoResultsProps) => {
  const renderIcon = () => {
    if (!icon) {
      return null;
    } else if (isValidElement(icon)) {
      return icon;
    } else {
      const IconComponent = icon as ElementType;
      return <IconComponent className={cx(css.icon, css[iconColor])} />;
    }
  };

  const renderTitle = () => {
    if (!title) {
      return null;
    } else if (_.isFunction(title)) {
      return title({ className: css.title });
    } else {
      return <p className={css.title}>{title}</p>;
    }
  };

  return (
    <div className={cx(css.container, className)} {...rest}>
      {renderIcon()}
      {renderTitle()}
      {message && <p className={css.message}>{message}</p>}
      {children}
    </div>
  );
};
